<template>
  <div class="cp" :class="{ 'mobile': !isDesktop }">
    <Mobile v-if="!isDesktop" />
    <cpMenu />
    <nuxt />
    <Error v-if="error" :error="error" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    cpMenu: () => import('~/components/cpMenu.vue'),
    Mobile: () => import('~/components/Mobile.vue'),
    Error: () => import('~/components/Error.vue')
  },
  computed: mapState(['error', 'isDesktop']),
}
</script>

<style lang="stylus">
.cp
  min-height: 100vh
  padding: 20px
  color: #ddd
  background-color: #222
  textarea
    border-radius: 4px
</style>